
export default {
    getContactNumbers: (state) => state.contactNumbers,
  }